/* ═══════════════ ATYR STUDIO — image self-heal (site-wide) ═══════════════
   Recovers images that fail to load, wherever they are. Three gaps it covers:

   1. A dropped request on mobile data — iOS then pins a broken-image glyph
      for the rest of the session, so we re-request with a cache-buster.
   2. Eager images start loading while the HTML is still parsing, i.e. BEFORE
      any listener exists. Their error event is lost, so we also sweep for
      images that finished loading with zero width.
   3. Back / Forward restores the page from the bfcache: no load event fires
      and anything broken stays broken. We re-sweep on pageshow.            */
(function () {
  'use strict';

  var MAX = 2;

  function bust(url, n) {
    var base = String(url).trim().replace(/[?&]atyr_r=\d+/g, '').replace(/[?&]$/, '');
    if (!base) return '';
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'atyr_r=' + n;
  }

  function isBroken(img) {
    return img.complete && img.naturalWidth === 0 && (img.getAttribute('src') || img.getAttribute('srcset'));
  }

  function heal(img) {
    if (!img || img.tagName !== 'IMG') return;
    var n = parseInt(img.getAttribute('data-atyr-heal') || '0', 10);
    if (n >= MAX) return;
    img.setAttribute('data-atyr-heal', n + 1);

    /* collection cards hide failed images via [data-broken]; clear it so a
       recovered image becomes visible again instead of staying at opacity 0 */
    img.removeAttribute('data-broken');

    var src = img.getAttribute('src') || '';
    var ss  = img.getAttribute('srcset') || '';
    if (!src && !ss) return;

    setTimeout(function () {
      if (ss) {
        /* the buster has to go on every srcset candidate — changing only
           src is ignored by the browser when a srcset is present */
        img.setAttribute('srcset', ss.split(',').map(function (part) {
          var bits = part.trim().split(/\s+/);
          if (!bits[0]) return part;
          bits[0] = bust(bits[0], n + 1);
          return bits.join(' ');
        }).join(', '));
      }
      if (src) img.setAttribute('src', bust(src, n + 1));
    }, 600 * (n + 1));
  }

  function sweep() {
    var imgs = document.images;
    for (var i = 0; i < imgs.length; i++) if (isBroken(imgs[i])) heal(imgs[i]);
  }

  /* live failures — capture phase, <img> error events don't bubble */
  document.addEventListener('error', function (e) {
    if (e.target && e.target.tagName === 'IMG') heal(e.target);
  }, true);

  /* failures from before this script existed */
  if (document.readyState === 'complete') sweep();
  else window.addEventListener('load', sweep);
  setTimeout(sweep, 3000);

  /* Back / Forward restore — give every image a fresh allowance and re-check */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var imgs = document.images;
    for (var i = 0; i < imgs.length; i++) imgs[i].removeAttribute('data-atyr-heal');
    setTimeout(sweep, 50);
  });

  /* coming back to a backgrounded tab */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) setTimeout(sweep, 200);
  });
}());
